module.exports = __webpack_public_path__ + "img/list.696aa841.svg";